import React from 'react'
import './styles.scss'

export const InlineMutation = ({
  protein,
  from,
  pos,
  to,
  arrow
}: Mutation & { arrow: boolean }) => {
  return (
    <div className={`inline-mutation ${arrow ? 'arrowed' : ''}`}>
      <div className='protein'>{protein}:</div>
      <div className='from'>{from}</div>
      <div className='pos'>{pos}</div>
      <div className='to'>{to}</div>
      {arrow && <div className='arrow' />}
    </div>
  )
}

InlineMutation.defaultProps = {
  arrow: false
}
